import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroll-component'
import { fetchUserDetailApi, notificationListApi } from '../../services/common';
import { GoBell } from 'react-icons/go';
import { formatFullDate } from '../../utils/dateTimeFormat';
import NotificationShimmer from '../../shimmer/notification/NotificationShimmer';
import { getToken, setJwtToken } from '../../config/AxiosInstance';
import { setShowAuth } from '../../store/slices/showAuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { setLiveDetail } from '../../store/slices/liveDetailSlice';

const Notification = () => {
    const [notificationList, setNotificationList] = useState([])
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const dispatch=useDispatch();
    const { liveDetail } = useSelector((state) => state?.liveDetail);

    const fetchUserDetail = async () => {
        if (getToken()) {
          try {
            const { data } = await fetchUserDetailApi({ token: getToken() });
            const { success, data: response } = data;
            if (success) {
              dispatch(setShowAuth(response));
            }
          } catch (e) {
            console.log("Error:-", e.message);
          }
        }
      };
    
      const fetchGoogleMeetHandler = async () => {
        if (getToken()) {
          try {
            const { data } = await axios.get(
              `${process.env.REACT_APP_API_URL}user/live/google-meet-auth`,
              setJwtToken()
            );
    
            const { data: liveMeetData, success, message, meta } = data;
            if (success) {
              dispatch(setLiveDetail(liveMeetData));
            }
          } catch (error) {
            dispatch(setLiveDetail({}));
            console.error(error?.message);
          }
        }
      };



    //----------favorite-listing-API-----------------
    const getNotificationList = async (page = 1, isRefresh = false) => {
        try {
            const { data } = await notificationListApi({
                pagination: "true",
                limit: 10,
                page: page,
            });
            const { data: response, success, message, meta } = data;
            if (success) {
                if (isRefresh) {
                    setNotificationList(response || []);
                } else {
                    setNotificationList((prev) => [...prev, ...(response || [])]);
                }
                setHasMore(response.length === 10);
            }
        } catch (e) {
            console.log("Error:-", e.message);
        }
    };

    useEffect(() => {
        setPage(1);
        setHasMore(true);
        getNotificationList(1, true);
    }, []);

    const fetchMoreData = () => {
        setPage((prevPage) => {
            const nextPage = prevPage + 1;
            getNotificationList(nextPage);
            return nextPage;
        });
    };


  useEffect(() => {
    fetchUserDetail();
    fetchGoogleMeetHandler();
  }, [getToken()]);


    return (
        <>
            <Dropdown.Menu>
                <div className="notification_parent"
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        scrollBehavior: "smooth",
                        paddingRight: "5px"
                    }}
                    id="scrollableContainer"
                >
                    <h4 className="notifi">Notification</h4>
                    <InfiniteScroll
                        dataLength={notificationList.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<NotificationShimmer count={5} />}
                        endMessage={
                            <p style={{ textAlign: "center", margin: "25px" }}>
                                <b>No more data to display</b>
                            </p>
                        }
                        scrollableTarget="scrollableContainer"
                    >
                        {notificationList && notificationList.length > 0 ? notificationList.map((data, ind) => (
                            <div key={ind} className="notification_list">
                                <div className="notification_request">
                                    <GoBell className="notifivation_icon" />
                                    <div className="notification_request">
                                        <p>
                                            <b>{''}</b> {data?.body}.  {formatFullDate(data?.createdAt)}</p>
                                    </div>
                                </div>
                            </div>
                        )) : null}
                    </InfiniteScroll>
                </div>
            </Dropdown.Menu>
        </>)
}

export default Notification